module.exports = __webpack_public_path__ + "img/iap-uam-mobile3.737b74b8.png";